import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

// Importar as imagens
import ceapSolLogo from '../assets/images/ceap-sol-logo.jpg';
import isgLogo from '../assets/images/isg-logo.png';

// Componente do Carrossel da Identidade Organizacional - OTIMIZADO
const IdentityCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const identityData = [
    {
      type: 'PROPÓSITO',
      title: 'Cuidar e Salvar Vidas',
      icon: '❤️',
      color: '#1976d2',
      description: 'Nosso compromisso fundamental com a vida e o bem-estar'
    },
    {
      type: 'MISSÃO',
      title: 'Promover cuidado e reabilitação em saúde',
      icon: '🎯',
      color: '#1976d2',
      description: 'Excelência em serviços de saúde pública'
    },
    {
      type: 'VISÃO',
      title: 'Ser referência em cuidados prolongados, reabilitação e inovação na área da saúde pública até 2027',
      icon: '👁️',
      color: '#d32f2f',
      description: 'Liderança e inovação em saúde pública'
    },
    {
      type: 'VALORES',
      title: 'Segurança, confiabilidade, acolhimento, transparência, sustentabilidade e humanização.',
      icon: '⭐',
      color: '#f57c00',
      description: 'Princípios que guiam nossas ações'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % identityData.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [identityData.length]);

  return (
    <Box sx={{ mb: 3 }}>
      {/* Container Principal com Imagens Laterais - OTIMIZADO */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          height: '120px'
        }}
      >
        {/* CEAP-SOL - Lado Esquerdo (Estático) - Imagem Completa */}
        <Box
          component="a"
          href="https://isgsaude.org.br/ceapsol/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            flex: '0 0 200px',
            height: '120px',
            borderRadius: '12px',
            overflow: 'hidden',
            background: '#ffffff',
            boxShadow: 'inset 0 4px 8px rgba(0,0,0,0.1), inset 0 2px 4px rgba(0,0,0,0.06), 0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            textDecoration: 'none',
            display: 'block',
            '&:hover': {
              transform: 'scale(0.98)',
              boxShadow: 'inset 0 6px 12px rgba(0,0,0,0.15), inset 0 3px 6px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.1)'
            }
          }}
        >
          <img 
            src={ceapSolLogo} 
            alt="CEAP-SOL Logo" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              borderRadius: '12px',
              background: 'transparent'
            }} 
          />
        </Box>

        {/* Container do Carrossel Central - OTIMIZADO */}
        <Box
          sx={{
            flex: 1,
            position: 'relative',
            height: '120px',  // Reduzido de 140px para 100px
            width: '800px',
            overflow: 'hidden',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e3f2fd 100%)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            border: '1px solid rgba(255,255,255,0.3)'
          }}
        >
        {/* Slides */}
        {identityData.map((item, index) => (
          <Box
            key={item.type}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: currentSlide === index ? 1 : 0,
              transform: currentSlide === index ? 'translateX(0)' : 'translateX(20px)',
              transition: 'all 0.6s ease-in-out'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '92%',
                maxWidth: '900px',
                background: 'rgba(255,255,255,0.95)',
                borderRadius: '8px',
                padding: '16px 20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                border: '1px solid rgba(255,255,255,0.4)'
              }}
            >
              {/* Ícone - SIMPLIFICADO */}
              <Box
                sx={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)'
                  }
                }}
              >
                {item.icon}
              </Box>

              {/* Conteúdo - SIMPLIFICADO */}
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}
                >
                  {item.type}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: '#1a1a1a',
                    fontWeight: 600,
                    lineHeight: 1.2,
                    mb: 0.5,
                    fontSize: '1rem'
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#666',
                    fontStyle: 'italic',
                    fontSize: '0.8rem'
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}

        {/* Indicadores - SIMPLIFICADOS */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '8px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '6px'
          }}
        >
          {identityData.map((item, index) => (
            <Box
              key={`dot-${item.type}`}
              sx={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: currentSlide === index ? '#1976d2' : 'rgba(255,255,255,0.6)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  background: currentSlide === index ? '#1976d2' : 'rgba(255,255,255,0.9)',
                  transform: 'scale(1.2)'
                }
              }}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </Box>
        </Box>

        {/* Instituto Sócrates Guanaes - Lado Direito (Estático) - Imagem Completa */}
        <Box
          component="a"
          href="https://isgsaude.org.br/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            flex: '0 0 200px',
            height: '120px',
            borderRadius: '12px',
            overflow: 'hidden',
            background: '#ffffff',
            boxShadow: 'inset 0 4px 8px rgba(0,0,0,0.1), inset 0 2px 4px rgba(0,0,0,0.06), 0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            textDecoration: 'none',
            display: 'block',
            '&:hover': {
              transform: 'scale(0.98)',
              boxShadow: 'inset 0 6px 12px rgba(0,0,0,0.15), inset 0 3px 6px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.1)'
            }
          }}
        >
          <img 
            src={isgLogo} 
            alt="ISG Logo" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              borderRadius: '12px',
              background: 'transparent'
            }} 
          />
        </Box>
      </Box>
    </Box>
  );
};

export default IdentityCarousel; 